<div class="application-status-page">
  <header class="header-bar">
    <img src="logo.png" alt="Logo" class="logo">
  </header>
  
  <main class="main-content">
    <h1>Your application is under review</h1>
    <p class="message">
      We've received your application and it's being reviewed. We'll email {{ data?.email || 'you' }} as soon as there's an update.
    </p>
  </main>
</div>
